import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../config';

function Inventory() {
  const [inventory, setInventory] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({ product_name: '', quantity: '', unit: '', low_stock_threshold: '', notes: '' });

  useEffect(() => {
    fetchInventory();
  }, []);

  const fetchInventory = async () => {
    const response = await axios.get(`${API_URL}/inventory`);
    setInventory(response.data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editingItem) {
      await axios.put(`${API_URL}/inventory/${editingItem.id}`, formData);
    } else {
      await axios.post(`${API_URL}/inventory`, formData);
    }
    setShowModal(false);
    setEditingItem(null);
    setFormData({ product_name: '', quantity: '', unit: '', low_stock_threshold: '', notes: '' });
    fetchInventory();
  };

  const deleteItem = async (id) => {
    if (window.confirm('Delete this item?')) {
      await axios.delete(`${API_URL}/inventory/${id}`);
      fetchInventory();
    }
  };

  return (
    <div className="inventory">
      <div className="header">
        <h2>Inventory</h2>
        <button onClick={() => setShowModal(true)}>Add Item</button>
      </div>
      <table>
        <thead>
          <tr>
            <th>Product</th>
            <th>Quantity</th>
            <th>Unit</th>
            <th>Low Stock Alert</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {inventory.map(item => (
            <tr key={item.id} className={item.quantity <= item.low_stock_threshold ? 'low-stock' : ''}>
              <td>{item.product_name}</td>
              <td>{item.quantity}</td>
              <td>{item.unit}</td>
              <td>{item.low_stock_threshold}</td>
              <td>
                {item.quantity <= item.low_stock_threshold ?
                  <span className="status low">Low Stock</span> :
                  <span className="status ok">OK</span>
                }
              </td>
              <td className="actions">
                <button onClick={() => { setEditingItem(item); setFormData(item); setShowModal(true); }} className="btn-small">Edit</button>
                <button onClick={() => deleteItem(item.id)} className="btn-small delete">Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <h3>{editingItem ? 'Edit Item' : 'Add Item'}</h3>
            <form onSubmit={handleSubmit}>
              <input type="text" placeholder="Product Name" value={formData.product_name} onChange={(e) => setFormData({...formData, product_name: e.target.value})} required />
              <input type="number" placeholder="Quantity" value={formData.quantity} onChange={(e) => setFormData({...formData, quantity: e.target.value})} required />
              <input type="text" placeholder="Unit (e.g., bottles, tubes)" value={formData.unit} onChange={(e) => setFormData({...formData, unit: e.target.value})} required />
              <input type="number" placeholder="Low Stock Threshold" value={formData.low_stock_threshold} onChange={(e) => setFormData({...formData, low_stock_threshold: e.target.value})} required />
              <textarea placeholder="Notes" value={formData.notes} onChange={(e) => setFormData({...formData, notes: e.target.value})} />
              <div className="modal-actions">
                <button type="submit">Save</button>
                <button type="button" onClick={() => { setShowModal(false); setEditingItem(null); setFormData({ product_name: '', quantity: '', unit: '', low_stock_threshold: '', notes: '' }); }}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Inventory;
